<div class="conversation_card">
    <div class="convesation-header">
        <span class="doctor">Doctor Who. MD</span>
        <span class="last-date">2/20/19</span>
    </div>
    <hr>
    <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit....</p>
</div>
